import { createResource } from 'react-resource-router';

import { getCompressionRatio } from '../endpoint';
import { type CompressionRatioResponse } from '../types';

const emptyCompressionBanner = {
	compressionRatio: 0,
	uniqueGroupCount: 0,
	rollingWindow: 0,
};

export const compressionRatioResource = createResource<CompressionRatioResponse>({
	type: 'compressionRatioResource',
	getKey: () => 'compressionRatioResource',
	getData: async () => {
		try {
			const response = await getCompressionRatio();
			return response;
		} catch (e) {
			return emptyCompressionBanner;
		}
	},
	maxAge: 5 * 60 * 1000, // 5 minutes
	isBrowserOnly: true,
});
